export default __webpack_public_path__ + "static/media/logo.f3b7e059.png";